var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/clock"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.6673 14.5612C25.6673 21.0012 20.4407 26.2279 14.0007 26.2279C7.56065 26.2279 2.33398 21.0012 2.33398 14.5612C2.33398 8.1212 7.56065 2.89453 14.0007 2.89453C20.4407 2.89453 25.6673 8.1212 25.6673 14.5612Z",
    stroke: "#A461D8",
    strokeWidth: 1.65833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.3284 18.2726L14.7117 16.1142C14.0817 15.7409 13.5684 14.8426 13.5684 14.1076V9.32422",
    stroke: "#A461D8",
    strokeWidth: 1.65833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.7c111dd91b4c23d3ce9458de85613e57.svg";
export { ForwardRef as ReactComponent };